import utils = egr.wcf.utils;
import { FloorPlanActions } from '../actions/FloorPlanActions';
import { ProjectInstance } from './ProjectInstance';
import { FloorPlanSettings, ProjectSettingsStore } from '../stores/ProjectSettingsStore';

export const FloorPlanContentFileName: string = 'floor_plan.data';

export abstract class FloorPlanManager {
    private static browserStorage: string | null = null;

    public static reset(): void {
        FloorPlanManager.browserStorage = null;
    }

    public static async updateTexture(dataUrl: string): Promise<void> {
        FloorPlanManager.browserStorage = dataUrl;
    }

    public static getFloorPlan(checkTmpPath: boolean = true, project?: ProjectInstance): string | null {
        return FloorPlanManager.browserStorage;
    }

    public static async importFloorPlanFromContainer(dataUrl: string): Promise<void> {
        await FloorPlanManager.updateTexture(dataUrl);
        await FloorPlanManager.loadFloorPlan(true);
    }

    public static async loadFloorPlan(checkTmpPath: boolean = false, project?: ProjectInstance): Promise<void> {
        const dataUrl: string | null = await FloorPlanManager.getFloorPlan(checkTmpPath, project);

        if (utils.string.isNullOrEmpty(dataUrl)) {
            return;
        }

        const settings: FloorPlanSettings | null = ProjectSettingsStore.getState().floorPlan;
        if (settings != null && settings.width != null && settings.height != null) {
            FloorPlanActions.setFloorPlanTexture(dataUrl, settings.width, settings.height, false);

            if (settings.brightness != null) {
                FloorPlanActions.setBrightness(settings.brightness);
            }

            if (settings.opacity != null) {
                FloorPlanActions.setVisibility(settings.opacity);
            }

            if (settings.colorReduction != null) {
                FloorPlanActions.setColorReduction(settings.colorReduction);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/FloorPlanManager.ts